import { render, staticRenderFns } from "./billingList.vue?vue&type=template&id=67d4005c&scoped=true&"
import script from "./billingList.vue?vue&type=script&lang=js&"
export * from "./billingList.vue?vue&type=script&lang=js&"
import style0 from "./billingList.vue?vue&type=style&index=0&id=67d4005c&lang=less&scoped=true&"
import style1 from "./billingList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4005c",
  null
  
)

export default component.exports